import { Modal } from "flowbite-react";
import React, { useCallback } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import {
  errorToast,
  successToast,
} from "../../../../../Components/ToastMessage";

const AddInterviewer = ({
  isInterviewerModalOpen,
  setIsInterviewerModalOpen,
  setInterviewers,
}) => {
  const handleSignup = useCallback(
    async (values, setSubmitting) => {
      try {
        const response = await axios.post("/users/add", {
          first_name: values.firstName,
          last_name: values.lastName,
          email: values.email,
          password: values.password,
          phone: values.phone,
        });
        if (response.data) {
          setInterviewers((prevData) => [...prevData, response.data]);
          successToast("Added Interviewer Successfully!");
          setIsInterviewerModalOpen(false);
        }
      } catch (error) {
        errorToast(error.message);
      } finally {
        setSubmitting(false);
      }
    },
    [setInterviewers, setIsInterviewerModalOpen]
  );

  // Formik for form handling and validation
  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      phone: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string()
        .max(20, "First name must be 20 characters or less")
        .required("First name is required"),
      lastName: Yup.string()
        .max(20, "Last name must be 20 characters or less")
        .required("Last name is required"),

      phone: Yup.string().required("Phone is required"),
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      password: Yup.string()
        .min(8, "Password must be at least 8 characters")
        .required("Password is required"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password"), null], "Passwords must match")
        .required("Confirm password is required"),
    }),
    onSubmit: (values, { setSubmitting }) => {
      handleSignup(values, setSubmitting);
    },
  });
  return (
    <Modal
      show={isInterviewerModalOpen}
      onClose={() => setIsInterviewerModalOpen(false)}
    >
      <Modal.Header>Add New Interviewer</Modal.Header>
      <Modal.Body>
        <form className="space-y-4" onSubmit={formik.handleSubmit}>
          <div className="flex space-x-4">
            <div className="w-1/2">
              <label className="block mb-2 font-semibold text-[#64748B]">
                First Name: <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="firstName"
                className={`border border-gray-300 rounded px-3 py-2 w-full ${
                  formik.touched.firstName && formik.errors.firstName
                    ? "border-red-500"
                    : ""
                }`}
                value={formik.values.firstName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.firstName && formik.errors.firstName && (
                <p className="text-red-500 text-sm">
                  {formik.errors.firstName}
                </p>
              )}
            </div>
            <div className="w-1/2">
              <label className="block mb-2 font-semibold text-[#64748B]">
                Last Name: <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="lastName"
                className={`border border-gray-300 rounded px-3 py-2 w-full ${
                  formik.touched.lastName && formik.errors.lastName
                    ? "border-red-500"
                    : ""
                }`}
                value={formik.values.lastName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.lastName && formik.errors.lastName && (
                <p className="text-red-500 text-sm">{formik.errors.lastName}</p>
              )}
            </div>
          </div>
          <div>
            <label className="block mb-2 font-semibold text-[#64748B]">
              Email: <span className="text-red-500">*</span>
            </label>
            <input
              type="email"
              name="email"
              className={`border border-gray-300 rounded px-3 py-2 w-full ${
                formik.touched.email && formik.errors.email
                  ? "border-red-500"
                  : ""
              }`}
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.email && formik.errors.email && (
              <p className="text-red-500 text-sm">{formik.errors.email}</p>
            )}
          </div>
          <div>
            <label className="block mb-2 font-semibold text-[#64748B]">
              Phone: <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="phone"
              className={`border border-gray-300 rounded px-3 py-2 w-full ${
                formik.touched.phone && formik.errors.phone
                  ? "border-red-500"
                  : ""
              }`}
              value={formik.values.phone}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.phone && formik.errors.phone && (
              <p className="text-red-500 text-sm">{formik.errors.phone}</p>
            )}
          </div>
          <div>
            <label className="block mb-2 font-semibold text-[#64748B]">
              Password: <span className="text-red-500">*</span>
            </label>
            <input
              type="password"
              name="password"
              className={`border border-gray-300 rounded px-3 py-2 w-full ${
                formik.touched.password && formik.errors.password
                  ? "border-red-500"
                  : ""
              }`}
              value={formik.values.password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.password && formik.errors.password && (
              <p className="text-red-500 text-sm">{formik.errors.password}</p>
            )}
          </div>
          <div>
            <label className="block mb-2 font-semibold text-[#64748B]">
              Confirm Password: <span className="text-red-500">*</span>
            </label>
            <input
              type="password"
              name="confirmPassword"
              className={`border border-gray-300 rounded px-3 py-2 w-full ${
                formik.touched.confirmPassword && formik.errors.confirmPassword
                  ? "border-red-500"
                  : ""
              }`}
              value={formik.values.confirmPassword}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.confirmPassword &&
              formik.errors.confirmPassword && (
                <p className="text-red-500 text-sm">
                  {formik.errors.confirmPassword}
                </p>
              )}
          </div>
          <div className="flex justify-end gap-5 text-[#64748B]">
            <button
              type="submit"
              className="mt-2 border-slate-500 px-5 py-2 rounded-md shadow-md hover:text-white hover:bg-slate-500 border-2 border-solid transition-all duration-300"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="mt-2 bg-slate-500 text-white px-5 py-2 rounded-md shadow-md hover:text-black hover:bg-transparent hover:border-slate-500 border-2 border-solid transition-all duration-300"
            >
              Add Interviewer
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default AddInterviewer;
